import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import { ProfilePageBannerData } from '@/modules/client-setting/type'
import ProfilePageBannerTable from '../ProfilePageBannerTable'
import CreateProfilePageBannerModal from '../CreateProfilePageBannerModal'

interface ProfilePageBannerListingProps {
	data: ProfilePageBannerData[]
	isLoading?: boolean
}

export default function ProfilePageBannerListing({
	data,
	isLoading,
}: ProfilePageBannerListingProps) {
	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading
					title="จัดการปุ่มทางเข้าเกม"
					description="จัดการปุ่มทางเข้าเกมในหน้าโปรไฟล์"
				/>
				<CreateProfilePageBannerModal />
			</div>
			<Separator />
			<ProfilePageBannerTable data={data} isLoading={isLoading} />
		</div>
	)
}
